// apps/web/src/views/app-views/roulette/inventory/index.js

import {
  Alert,
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Image,
  Input,
  InputNumber,
  Modal,
  Radio,
  Row,
  Select,
  Space,
  Statistic,
  Switch,
  Table,
  Tabs,
  Tag,
  Typography,
  message,
} from 'antd'
import {
  AuditOutlined,
  CalendarOutlined,
  CheckCircleOutlined,
  DeleteOutlined,
  HistoryOutlined,
  InboxOutlined,
  MinusCircleOutlined,
  PlusCircleOutlined,
  ReloadOutlined,
  SettingOutlined,
  StopOutlined,
  WarningOutlined,
} from '@ant-design/icons'
import { useEffect, useMemo, useState } from 'react'
import moment from 'moment'
import RouletteInventoryService from 'services/RouletteInventoryService'
import { api } from 'services/api'

const { Title, Text } = Typography

const API_BASE_URL =
  process.env.REACT_APP_API_URL ||
  'http://localhost:3001'

const MOVEMENT_LABELS = {
  INITIAL: 'Estoque inicial',
  ENTRY: 'Entrada',
  EXIT: 'Saída',
  DELIVERY: 'Entrega',
  RETURN: 'Retorno',
  ADJUSTMENT: 'Ajuste',
}

const MOVEMENT_COLORS = {
  INITIAL: 'blue',
  ENTRY: 'green',
  EXIT: 'volcano',
  DELIVERY: 'purple',
  RETURN: 'cyan',
  ADJUSTMENT: 'gold',
}

const DELIVERY_LABELS = {
  PENDING: 'Pendente',
  DELIVERED: 'Entregue',
  CANCELLED: 'Cancelada',
}

const DELIVERY_COLORS = {
  PENDING: 'gold',
  DELIVERED: 'green',
  CANCELLED: 'red',
}

const getImageUrl = (url) => {
  if (!url) {
    return null
  }

  if (url.startsWith('http')) {
    return url
  }

  return `${API_BASE_URL}${url}`
}

const unwrapResponse = (response) => {
  return response?.data || response
}

const normalizeList = (response) => {
  const data = unwrapResponse(response)

  if (Array.isArray(data)) {
    return data
  }

  if (Array.isArray(data?.items)) {
    return data.items
  }

  return []
}

const formatDateTime = (value) => {
  if (!value) {
    return '-'
  }

  return new Date(value).toLocaleString('pt-BR')
}

const getTodayDate = () => {
  return moment().format('YYYY-MM-DD')
}

const InventoryPage = () => {
  const [games, setGames] = useState([])
  const [gameId, setGameId] = useState()

  const [prizes, setPrizes] = useState([])
  const [loading, setLoading] = useState(false)

  const [movementModalOpen, setMovementModalOpen] =
    useState(false)

  const [configurationModalOpen, setConfigurationModalOpen] =
    useState(false)

  const [historyModalOpen, setHistoryModalOpen] =
    useState(false)

  const [deliveriesModalOpen, setDeliveriesModalOpen] =
    useState(false)

    const [inventoryModalOpen, setInventoryModalOpen] =
  useState(false)

const [
  inventoryHistoryModalOpen,
  setInventoryHistoryModalOpen,
] = useState(false)

const [inventories, setInventories] =
  useState([])

const [
  inventoriesLoading,
  setInventoriesLoading,
] = useState(false)

const [
  inventorySubmitting,
  setInventorySubmitting,
] = useState(false)

  const [selectedPrize, setSelectedPrize] =
    useState(null)

  const [movementType, setMovementType] =
    useState('entry')

  const [submittingMovement, setSubmittingMovement] =
    useState(false)

  const [
    submittingConfiguration,
    setSubmittingConfiguration,
  ] = useState(false)

  const [historyLoading, setHistoryLoading] =
    useState(false)

  const [movements, setMovements] =
    useState([])

  const [deliveries, setDeliveries] =
    useState([])

  const [deliveriesLoading, setDeliveriesLoading] =
    useState(false)

 const [movementForm] = Form.useForm()
const [configurationForm] = Form.useForm()
const [inventoryForm] = Form.useForm()

  const selectedGame = useMemo(() => {
    return games.find(
      (game) => game.id === gameId,
    )
  }, [games, gameId])

  const totalStock = useMemo(() => {
    return prizes.reduce(
      (total, prize) =>
        total +
        Number(prize.stockAvailable || 0),
      0,
    )
  }, [prizes])

  const totalInitialStock = useMemo(() => {
    return prizes.reduce(
      (total, prize) =>
        total +
        Number(prize.stockInitial || 0),
      0,
    )
  }, [prizes])

  const totalDailyLimit = useMemo(() => {
    return prizes.reduce(
      (total, prize) =>
        total +
        Number(
          prize.dailyLimit === null ||
            prize.dailyLimit === undefined
            ? 0
            : prize.dailyLimit,
        ),
      0,
    )
  }, [prizes])

  const totalDistributedToday = useMemo(() => {
    return prizes.reduce(
      (total, prize) =>
        total +
        Number(
          prize.distributedToday || 0,
        ),
      0,
    )
  }, [prizes])

  const totalAvailableToday = useMemo(() => {
    return prizes.reduce(
      (total, prize) =>
        total +
        Number(
          prize.availableToday || 0,
        ),
      0,
    )
  }, [prizes])

  const loadGames = async () => {
    try {
      const response =
        await api.get('/games')

      const list = normalizeList(response)

      setGames(list)

      if (
        list.length &&
        !gameId
      ) {
        setGameId(list[0].id)
      }
    } catch (error) {
      console.error(
        'ERRO AO CARREGAR JOGOS:',
        error,
      )

      message.error(
        error?.response?.data?.message ||
          'Erro ao carregar jogos',
      )
    }
  }

  const loadPrizeDailyData = async (
    prize,
  ) => {
    const today = getTodayDate()

    let effectiveConfiguration = null
    let deliveriesList = []

    try {
      const configurationResponse =
        await api.get(
          `/prizes/${prize.id}/configurations/effective?date=${today}`,
        )

      effectiveConfiguration =
        unwrapResponse(
          configurationResponse,
        )
    } catch (error) {
      console.error(
        `ERRO NA CONFIGURAÇÃO DO BRINDE ${prize.id}:`,
        error,
      )
    }

    try {
      const deliveriesResponse =
        await api.get(
          `/prizes/${prize.id}/deliveries?page=1&limit=100`,
        )

      deliveriesList =
        normalizeList(deliveriesResponse)
    } catch (error) {
      console.error(
        `ERRO NAS ENTREGAS DO BRINDE ${prize.id}:`,
        error,
      )
    }

    const distributedToday =
      deliveriesList.filter(
        (delivery) => {
          if (
            delivery.status ===
            'CANCELLED'
          ) {
            return false
          }

          const createdAt =
            delivery.createdAt ||
            delivery.spin?.createdAt

          if (!createdAt) {
            return false
          }

          return (
            moment(createdAt).format(
              'YYYY-MM-DD',
            ) === today
          )
        },
      ).length

    const dailyLimit =
      effectiveConfiguration?.dailyLimit ??
      null

    const availableByDailyLimit =
      dailyLimit === null
        ? Number(
            prize.stockAvailable || 0,
          )
        : Math.max(
            Number(dailyLimit) -
              distributedToday,
            0,
          )

    const availableToday = Math.min(
      Number(prize.stockAvailable || 0),
      availableByDailyLimit,
    )

    return {
      ...prize,

      dailyLimit,

      dailyEnabled:
        effectiveConfiguration?.enabled ??
        prize.isActive,

      probabilityWeightToday:
        effectiveConfiguration
          ?.probabilityWeight ??
        prize.probabilityWeight,

      configurationId:
        effectiveConfiguration
          ?.configurationId ??
        null,

      hasSpecificConfiguration:
        effectiveConfiguration
          ?.hasSpecificConfiguration ??
        false,

      configurationNotes:
        effectiveConfiguration?.notes ??
        null,

      distributedToday,

      availableToday,

      dailyLimitReached:
        dailyLimit !== null &&
        distributedToday >= dailyLimit,

      deliveriesToday:
        deliveriesList,
    }
  }

  const loadInventory = async (
    selectedGameId,
  ) => {
    if (!selectedGameId) {
      setPrizes([])
      return
    }

    setLoading(true)

    try {
      const prizesResponse =
        await api.get(
          `/prizes?gameId=${selectedGameId}`,
        )

      const prizeList =
        normalizeList(prizesResponse)

      const enrichedPrizes =
        await Promise.all(
          prizeList.map(
            loadPrizeDailyData,
          ),
        )

      setPrizes(
        enrichedPrizes
          .slice()
          .sort(
            (a, b) =>
              Number(a.position || 0) -
              Number(b.position || 0),
          ),
      )
    } catch (error) {
      console.error(
        'ERRO AO CARREGAR ESTOQUE:',
        error,
      )

      message.error(
        error?.response?.data?.message ||
          'Erro ao carregar estoque dos brindes',
      )
    } finally {
      setLoading(false)
    }
  }

  const loadMovements = async (
    prizeId,
  ) => {
    if (!prizeId) {
      setMovements([])
      return
    }

    setHistoryLoading(true)

    try {
      const response =
        await api.get(
          `/prizes/${prizeId}/movements?page=1&limit=100`,
        )

      setMovements(
        normalizeList(response),
      )
    } catch (error) {
      console.error(
        'ERRO AO CARREGAR MOVIMENTAÇÕES:',
        error,
      )

      setMovements([])

      message.error(
        error?.response?.data?.message ||
          'Erro ao carregar movimentações',
      )
    } finally {
      setHistoryLoading(false)
    }
  }

  const loadDeliveries = async (
    prizeId,
  ) => {
    if (!prizeId) {
      setDeliveries([])
      return
    }

    setDeliveriesLoading(true)

    try {
      const response =
        await api.get(
          `/prizes/${prizeId}/deliveries?page=1&limit=100`,
        )

      setDeliveries(
        normalizeList(response),
      )
    } catch (error) {
      console.error(
        'ERRO AO CARREGAR ENTREGAS:',
        error,
      )

      setDeliveries([])

      message.error(
        error?.response?.data?.message ||
          'Erro ao carregar entregas',
      )
    } finally {
      setDeliveriesLoading(false)
    }
  }

  const openMovementModal = (
    prize,
    action = 'entry',
  ) => {
    setSelectedPrize(prize)
    setMovementType(action)

    movementForm.resetFields()

    movementForm.setFieldsValue({
      action,
      quantity: 1,
      newStock:
        prize.stockAvailable || 0,
      notes: null,
    })

    setMovementModalOpen(true)
  }

  const closeMovementModal = () => {
    setMovementModalOpen(false)
    setSelectedPrize(null)
    setMovementType('entry')
    movementForm.resetFields()
  }

  const handleMovementTypeChange = (
    event,
  ) => {
    const action =
      event.target.value

    setMovementType(action)

    movementForm.setFieldsValue({
      action,
      quantity: 1,
      newStock:
        selectedPrize?.stockAvailable ||
        0,
      notes: null,
    })
  }

  const submitMovement = async (
    values,
  ) => {
    if (!selectedPrize?.id) {
      message.error(
        'Nenhum brinde selecionado',
      )
      return
    }

    setSubmittingMovement(true)

    try {
      const action =
        values.action ||
        movementType

      if (action === 'entry') {
        await api.post(
          `/prizes/${selectedPrize.id}/stock/entry`,
          {
            quantity: Number(
              values.quantity,
            ),
            notes:
              values.notes || null,
          },
        )

        message.success(
          'Entrada registrada',
        )
      }

      if (action === 'exit') {
        await api.post(
          `/prizes/${selectedPrize.id}/stock/exit`,
          {
            quantity: Number(
              values.quantity,
            ),
            notes:
              values.notes || null,
          },
        )

        message.success(
          'Saída registrada',
        )
      }

      if (action === 'return') {
        await api.post(
          `/prizes/${selectedPrize.id}/stock/return`,
          {
            quantity: Number(
              values.quantity,
            ),
            notes:
              values.notes || null,
          },
        )

        message.success(
          'Devolução registrada',
        )
      }

      if (action === 'adjust') {
        await api.post(
          `/prizes/${selectedPrize.id}/stock/adjust`,
          {
            newStock: Number(
              values.newStock,
            ),
            notes:
              values.notes || null,
          },
        )

        message.success(
          'Estoque ajustado',
        )
      }

      closeMovementModal()

      await loadInventory(gameId)
    } catch (error) {
      console.error(
        'ERRO AO MOVIMENTAR ESTOQUE:',
        error,
      )

      message.error(
        error?.response?.data?.message ||
          'Erro ao movimentar estoque',
      )
    } finally {
      setSubmittingMovement(false)
    }
  }

  const openConfigurationModal = (
    prize,
  ) => {
    setSelectedPrize(prize)

    configurationForm.resetFields()

    configurationForm.setFieldsValue({
      date: moment(),
      enabled:
        prize.dailyEnabled ??
        prize.isActive ??
        true,
      dailyLimit:
        prize.dailyLimit,
      probabilityWeight:
        prize.probabilityWeightToday ??
        prize.probabilityWeight,
      notes:
        prize.configurationNotes ||
        null,
    })

    setConfigurationModalOpen(true)
  }

  const closeConfigurationModal = () => {
    setConfigurationModalOpen(false)
    setSelectedPrize(null)
    configurationForm.resetFields()
  }

  const submitConfiguration = async (
    values,
  ) => {
    if (!selectedPrize?.id) {
      message.error(
        'Nenhum brinde selecionado',
      )
      return
    }

    setSubmittingConfiguration(true)

    try {
      const date = values.date
        ? values.date.format(
            'YYYY-MM-DD',
          )
        : getTodayDate()

      const payload = {
        date,

        enabled:
          values.enabled ?? true,

        dailyLimit:
          values.dailyLimit ===
            undefined ||
          values.dailyLimit === null
            ? null
            : Number(
                values.dailyLimit,
              ),

        probabilityWeight:
          values.probabilityWeight ===
            undefined ||
          values.probabilityWeight === null
            ? null
            : Number(
                values.probabilityWeight,
              ),

        notes:
          values.notes || null,
      }

      const configurationsResponse =
        await api.get(
          `/prizes/${selectedPrize.id}/configurations`,
        )

      const configurations =
        normalizeList(
          configurationsResponse,
        )

      const existingConfiguration =
        configurations.find(
          (configuration) =>
            moment(
              configuration.date,
            ).format('YYYY-MM-DD') ===
            date,
        )

      if (existingConfiguration) {
        await api.patch(
          `/prizes/configurations/${existingConfiguration.id}`,
          payload,
        )

        message.success(
          'Configuração diária atualizada',
        )
      } else {
        await api.post(
          `/prizes/${selectedPrize.id}/configurations`,
          payload,
        )

        message.success(
          'Configuração diária criada',
        )
      }

      closeConfigurationModal()

      await loadInventory(gameId)
    } catch (error) {
      console.error(
        'ERRO AO SALVAR CONFIGURAÇÃO:',
        error,
      )

      message.error(
        error?.response?.data?.message ||
          'Erro ao salvar configuração diária',
      )
    } finally {
      setSubmittingConfiguration(false)
    }
  }

  const openHistoryModal = async (
    prize,
  ) => {
    setSelectedPrize(prize)
    setMovements([])
    setHistoryModalOpen(true)

    await loadMovements(prize.id)
  }

  const closeHistoryModal = () => {
    setHistoryModalOpen(false)
    setSelectedPrize(null)
    setMovements([])
  }

  const loadInventories = async (
  prizeId,
) => {
  if (!prizeId) {
    setInventories([])
    return
  }

  setInventoriesLoading(true)

  try {
    const response =
      await RouletteInventoryService.getInventories(
        prizeId,
        {
          page: 1,
          limit: 100,
        },
      )

    const items = Array.isArray(response)
      ? response
      : Array.isArray(response?.items)
        ? response.items
        : []

    setInventories(items)
  } catch (error) {
    console.error(
      'ERRO AO CARREGAR INVENTÁRIOS:',
      error,
    )

    setInventories([])

    message.error(
      error?.response?.data?.message ||
        'Erro ao carregar inventários',
    )
  } finally {
    setInventoriesLoading(false)
  }
}

const openInventoryModal = (
  prize,
) => {
  setSelectedPrize(prize)

  inventoryForm.resetFields()

  inventoryForm.setFieldsValue({
    expectedStock:
      Number(
        prize.stockAvailable || 0,
      ),
    countedStock:
      Number(
        prize.stockAvailable || 0,
      ),
    notes: null,
  })

  setInventoryModalOpen(true)
}

const closeInventoryModal = () => {
  setInventoryModalOpen(false)
  setSelectedPrize(null)
  inventoryForm.resetFields()
}

const submitInventory = async (
  values,
) => {
  if (!selectedPrize?.id) {
    message.error(
      'Nenhum brinde selecionado',
    )
    return
  }

  setInventorySubmitting(true)

  try {
    await RouletteInventoryService.createInventory(
      selectedPrize.id,
      {
        countedStock:
          values.countedStock,
        notes:
          values.notes,
      },
    )

    message.success(
      'Inventário registrado e estoque conferido',
    )

    closeInventoryModal()

    await loadInventory(gameId)
  } catch (error) {
    console.error(
      'ERRO AO REGISTRAR INVENTÁRIO:',
      error,
    )

    message.error(
      error?.response?.data?.message ||
        'Erro ao registrar inventário',
    )
  } finally {
    setInventorySubmitting(false)
  }
}

const openInventoryHistoryModal = async (
  prize,
) => {
  setSelectedPrize(prize)
  setInventories([])
  setInventoryHistoryModalOpen(true)

  await loadInventories(prize.id)
}

const closeInventoryHistoryModal = () => {
  setInventoryHistoryModalOpen(false)
  setSelectedPrize(null)
  setInventories([])
}

const deleteInventory = async (
  inventoryId,
) => {
  try {
    await RouletteInventoryService.deleteInventory(
      inventoryId,
    )

    message.success(
      'Inventário removido',
    )

    await loadInventories(
      selectedPrize.id,
    )
  } catch (error) {
    message.error(
      error?.response?.data?.message ||
        'Erro ao remover inventário',
    )
  }
}

  const openDeliveriesModal = async (
    prize,
  ) => {
    setSelectedPrize(prize)
    setDeliveries([])
    setDeliveriesModalOpen(true)

    await loadDeliveries(prize.id)
  }

  const closeDeliveriesModal = () => {
    setDeliveriesModalOpen(false)
    setSelectedPrize(null)
    setDeliveries([])
  }

  const confirmDelivery = async (
    deliveryId,
  ) => {
    try {
      await api.patch(
        `/prizes/deliveries/${deliveryId}/deliver`,
        {},
      )

      message.success(
        'Entrega confirmada',
      )

      await loadDeliveries(
        selectedPrize.id,
      )

      await loadInventory(gameId)
    } catch (error) {
      message.error(
        error?.response?.data?.message ||
          'Erro ao confirmar entrega',
      )
    }
  }

  const cancelDelivery = async (
    deliveryId,
  ) => {
    try {
      await api.patch(
        `/prizes/deliveries/${deliveryId}/cancel`,
        {},
      )

      message.success(
        'Entrega cancelada',
      )

      await loadDeliveries(
        selectedPrize.id,
      )

      await loadInventory(gameId)
    } catch (error) {
      message.error(
        error?.response?.data?.message ||
          'Erro ao cancelar entrega',
      )
    }
  }

  const reopenDelivery = async (
    deliveryId,
  ) => {
    try {
      await api.patch(
        `/prizes/deliveries/${deliveryId}/reopen`,
        {},
      )

      message.success(
        'Entrega reaberta',
      )

      await loadDeliveries(
        selectedPrize.id,
      )

      await loadInventory(gameId)
    } catch (error) {
      message.error(
        error?.response?.data?.message ||
          'Erro ao reabrir entrega',
      )
    }
  }

  useEffect(() => {
    loadGames()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    loadInventory(gameId)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gameId])

  const watchedExpectedStock =
  Form.useWatch(
    'expectedStock',
    inventoryForm,
  )

const watchedCountedStock =
  Form.useWatch(
    'countedStock',
    inventoryForm,
  )

const inventoryDifference =
  Number(
    watchedCountedStock || 0,
  ) -
  Number(
    watchedExpectedStock || 0,
  )

  const inventoryColumns = [
    {
      title: 'Brinde',
      width: 270,
      fixed: 'left',
      render: (_, prize) => (
        <Space>
          <div
            style={{
              width: 64,
              height: 52,
              borderRadius: 10,
              background: '#f5f5f5',
              border:
                '1px solid #e5e7eb',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              overflow: 'hidden',
            }}
          >
            {prize.imageUrl ? (
              <Image
                src={getImageUrl(
                  prize.imageUrl,
                )}
                preview={false}
                style={{
                  maxWidth: 58,
                  maxHeight: 46,
                  objectFit: 'contain',
                }}
              />
            ) : (
              <InboxOutlined
                style={{
                  fontSize: 24,
                  color: '#999',
                }}
              />
            )}
          </div>

          <div>
            <Text strong>
              {prize.name}
            </Text>

            <div>
              <Text type="secondary">
                Posição{' '}
                {prize.position || 0}
              </Text>
            </div>
          </div>
        </Space>
      ),
    },
    {
      title: 'Estoque atual',
      dataIndex: 'stockAvailable',
      width: 130,
      sorter: (a, b) =>
        Number(
          a.stockAvailable || 0,
        ) -
        Number(
          b.stockAvailable || 0,
        ),
      render: (value, prize) => (
        <Tag
          color={
            Number(value) > 0
              ? 'green'
              : 'red'
          }
        >
          {Number(value || 0)} /{' '}
          {Number(
            prize.stockInitial || 0,
          )}
        </Tag>
      ),
    },
    {
      title: 'Limite diário',
      dataIndex: 'dailyLimit',
      width: 130,
      render: (value) =>
        value === null ||
        value === undefined ? (
          <Tag>Sem limite</Tag>
        ) : (
          <Tag color="blue">
            {value}
          </Tag>
        ),
    },
    {
      title: 'Distribuídos hoje',
      dataIndex:
        'distributedToday',
      width: 150,
      sorter: (a, b) =>
        Number(
          a.distributedToday || 0,
        ) -
        Number(
          b.distributedToday || 0,
        ),
      render: (value) => (
        <Tag color="purple">
          {Number(value || 0)}
        </Tag>
      ),
    },
    {
      title: 'Disponível hoje',
      dataIndex: 'availableToday',
      width: 140,
      sorter: (a, b) =>
        Number(
          a.availableToday || 0,
        ) -
        Number(
          b.availableToday || 0,
        ),
      render: (value) => (
        <Tag
          color={
            Number(value) > 0
              ? 'cyan'
              : 'red'
          }
        >
          {Number(value || 0)}
        </Tag>
      ),
    },
    {
      title: 'Probabilidade',
      dataIndex:
        'probabilityWeightToday',
      width: 130,
      render: (value) => (
        <Tag color="geekblue">
          Peso {value || 0}
        </Tag>
      ),
    },
    {
      title: 'Status',
      width: 150,
      render: (_, prize) => {
        if (!prize.isActive) {
          return (
            <Tag
              color="red"
              icon={<StopOutlined />}
            >
              Inativo
            </Tag>
          )
        }

        if (
          prize.stockAvailable <= 0
        ) {
          return (
            <Tag
              color="red"
              icon={
                <WarningOutlined />
              }
            >
              Sem estoque
            </Tag>
          )
        }

        if (
          prize.dailyLimitReached
        ) {
          return (
            <Tag
              color="orange"
              icon={
                <CalendarOutlined />
              }
            >
              Limite atingido
            </Tag>
          )
        }

        return (
          <Tag
            color="green"
            icon={
              <CheckCircleOutlined />
            }
          >
            Disponível
          </Tag>
        )
      },
    },
    {
      title: 'Ações',
      width: 440,
      fixed: 'right',
      render: (_, prize) => (
        <Space wrap>
          <Button
            size="small"
            type="primary"
            ghost
            icon={
              <PlusCircleOutlined />
            }
            onClick={() =>
              openMovementModal(
                prize,
                'entry',
              )
            }
          >
            Entrada
          </Button>

          <Button
            size="small"
            danger
            ghost
            icon={
              <MinusCircleOutlined />
            }
            onClick={() =>
              openMovementModal(
                prize,
                'exit',
              )
            }
          >
            Saída
          </Button>

          <Button
            size="small"
            icon={<SettingOutlined />}
            onClick={() =>
              openConfigurationModal(
                prize,
              )
            }
          >
            Limite diário
          </Button>
            <Button
  size="small"
  icon={<AuditOutlined />}
  onClick={() =>
    openInventoryModal(prize)
  }
>
  Inventário
</Button>

<Button
  size="small"
  icon={<HistoryOutlined />}
  onClick={() =>
    openInventoryHistoryModal(
      prize,
    )
  }
>
  Conferências
</Button>
          <Button
            size="small"
            icon={<HistoryOutlined />}
            onClick={() =>
              openHistoryModal(prize)
            }
          >
            Histórico
          </Button>

          <Button
            size="small"
            icon={<InboxOutlined />}
            onClick={() =>
              openDeliveriesModal(
                prize,
              )
            }
          >
            Entregas
          </Button>
        </Space>
      ),
    },
  ]

  return (
    <>
      <Space
        style={{
          width: '100%',
          justifyContent:
            'space-between',
          marginBottom: 16,
        }}
      >
        <div>
          <Title
            level={2}
            style={{ margin: 0 }}
          >
            Estoque de Brindes
          </Title>

          <p>
            Controle o estoque, limites
            diários, movimentações e
            entregas dos brindes.
          </p>
        </div>

        <Button
          icon={<ReloadOutlined />}
          loading={loading}
          onClick={() =>
            loadInventory(gameId)
          }
        >
          Atualizar
        </Button>
      </Space>

      <Card
        style={{ marginBottom: 16 }}
      >
        <Select
          style={{
            width: 520,
            maxWidth: '100%',
          }}
          placeholder="Selecione o jogo"
          value={gameId}
          onChange={setGameId}
          showSearch
          optionFilterProp="children"
        >
          {games.map((game) => (
            <Select.Option
              key={game.id}
              value={game.id}
            >
              {game.name}
              {game.event?.name
                ? ` - ${game.event.name}`
                : ''}
            </Select.Option>
          ))}
        </Select>
      </Card>

      <Row
        gutter={[16, 16]}
        style={{ marginBottom: 16 }}
      >
        <Col
          xs={24}
          sm={12}
          xl={5}
        >
          <Card>
            <Statistic
              title="Estoque disponível"
              value={totalStock}
              prefix={<InboxOutlined />}
            />
          </Card>
        </Col>

        <Col
          xs={24}
          sm={12}
          xl={5}
        >
          <Card>
            <Statistic
              title="Estoque inicial"
              value={totalInitialStock}
              prefix={
                <PlusCircleOutlined />
              }
            />
          </Card>
        </Col>

        <Col
          xs={24}
          sm={12}
          xl={5}
        >
          <Card>
            <Statistic
              title="Limite diário"
              value={totalDailyLimit}
              prefix={
                <CalendarOutlined />
              }
            />
          </Card>
        </Col>

        <Col
          xs={24}
          sm={12}
          xl={5}
        >
          <Card>
            <Statistic
              title="Distribuídos hoje"
              value={
                totalDistributedToday
              }
              prefix={
                <CheckCircleOutlined />
              }
            />
          </Card>
        </Col>

        <Col
          xs={24}
          sm={12}
          xl={4}
        >
          <Card>
            <Statistic
              title="Disponíveis hoje"
              value={
                totalAvailableToday
              }
              prefix={
                <ReloadOutlined />
              }
            />
          </Card>
        </Col>
      </Row>

      <Card
        title="Controle por brinde"
        extra={
          <Text type="secondary">
            {selectedGame?.name ||
              'Nenhum jogo selecionado'}
          </Text>
        }
      >
        <Table
          rowKey="id"
          loading={loading}
          dataSource={prizes}
          columns={inventoryColumns}
          pagination={{
            pageSize: 10,
            showSizeChanger: true,
            pageSizeOptions: [
              '10',
              '20',
              '50',
            ],
          }}
          scroll={{ x: 1550 }}
        />

        <Alert
          showIcon
          type="info"
          style={{ marginTop: 16 }}
          message="O limite diário não altera o estoque total. Quando o limite do dia for atingido, o brinde fica indisponível até o próximo dia."
        />
      </Card>
          <Modal
  title={
    selectedPrize
      ? `Inventário físico — ${selectedPrize.name}`
      : 'Inventário físico'
  }
  visible={inventoryModalOpen}
  onCancel={closeInventoryModal}
  footer={null}
  destroyOnClose
  width={680}
>
  <Alert
    showIcon
    type="info"
    style={{ marginBottom: 20 }}
    message="Conte fisicamente os brindes disponíveis. Caso exista diferença, o estoque será ajustado automaticamente."
  />

  <Form
    layout="vertical"
    form={inventoryForm}
    onFinish={submitInventory}
  >
    <Row gutter={16}>
      <Col xs={24} md={12}>
        <Form.Item
          name="expectedStock"
          label="Estoque esperado pelo sistema"
        >
          <InputNumber
            disabled
            precision={0}
            style={{
              width: '100%',
            }}
          />
        </Form.Item>
      </Col>

      <Col xs={24} md={12}>
        <Form.Item
          name="countedStock"
          label="Quantidade contada"
          rules={[
            {
              required: true,
              message:
                'Informe a quantidade contada',
            },
            {
              type: 'number',
              min: 0,
              message:
                'A quantidade não pode ser negativa',
            },
          ]}
        >
          <InputNumber
            min={0}
            precision={0}
            style={{
              width: '100%',
            }}
          />
        </Form.Item>
      </Col>
    </Row>

    <Card
      size="small"
      style={{
        marginBottom: 20,
      }}
    >
      <Statistic
        title="Diferença encontrada"
        value={inventoryDifference}
        prefix={
          inventoryDifference === 0
            ? <CheckCircleOutlined />
            : <WarningOutlined />
        }
        valueStyle={{
          color:
            inventoryDifference === 0
              ? '#3f8600'
              : inventoryDifference > 0
                ? '#1677ff'
                : '#cf1322',
        }}
      />

      <div
        style={{
          marginTop: 8,
        }}
      >
        {inventoryDifference === 0 && (
          <Tag color="green">
            Estoque correto
          </Tag>
        )}

        {inventoryDifference > 0 && (
          <Tag color="blue">
            Sobra de{' '}
            {inventoryDifference}
          </Tag>
        )}

        {inventoryDifference < 0 && (
          <Tag color="red">
            Falta de{' '}
            {Math.abs(
              inventoryDifference,
            )}
          </Tag>
        )}
      </div>
    </Card>

    <Form.Item
      name="notes"
      label="Observação"
      rules={[
        {
          validator: (_, value) => {
            if (
              inventoryDifference !== 0 &&
              !value?.trim()
            ) {
              return Promise.reject(
                new Error(
                  'Informe o motivo da diferença encontrada',
                ),
              )
            }

            return Promise.resolve()
          },
        },
      ]}
    >
      <Input.TextArea
        rows={4}
        placeholder="Ex.: duas unidades danificadas, sobra encontrada no depósito..."
      />
    </Form.Item>

    <Space>
      <Button
        type="primary"
        htmlType="submit"
        loading={inventorySubmitting}
        icon={<AuditOutlined />}
      >
        Registrar inventário
      </Button>

      <Button
        onClick={closeInventoryModal}
      >
        Cancelar
      </Button>
    </Space>
  </Form>
</Modal>
<Modal
  title={
    selectedPrize
      ? `Conferências de estoque — ${selectedPrize.name}`
      : 'Histórico de inventários'
  }
  visible={
    inventoryHistoryModalOpen
  }
  onCancel={
    closeInventoryHistoryModal
  }
  footer={null}
  destroyOnClose
  width={1050}
>
  <Table
    rowKey="id"
    loading={inventoriesLoading}
    dataSource={inventories}
    pagination={{
      pageSize: 10,
      showSizeChanger: false,
    }}
    scroll={{ x: 950 }}
    columns={[
      {
        title: 'Data',
        dataIndex: 'createdAt',
        width: 170,
        render: formatDateTime,
      },
      {
        title: 'Esperado',
        dataIndex: 'expectedStock',
        width: 110,
      },
      {
        title: 'Contado',
        dataIndex: 'countedStock',
        width: 110,
      },
      {
        title: 'Diferença',
        dataIndex: 'difference',
        width: 120,
        render: (value) => {
          const difference =
            Number(value || 0)

          if (difference === 0) {
            return (
              <Tag color="green">
                Correto
              </Tag>
            )
          }

          if (difference > 0) {
            return (
              <Tag color="blue">
                +{difference}
              </Tag>
            )
          }

          return (
            <Tag color="red">
              {difference}
            </Tag>
          )
        },
      },
      {
        title: 'Responsável',
        width: 180,
        render: (_, inventory) =>
          inventory.user?.name ||
          inventory.user?.email ||
          'Não informado',
      },
      {
        title: 'Observação',
        dataIndex: 'notes',
        render: (value) =>
          value || '-',
      },
      {
        title: 'Ações',
        width: 100,
        fixed: 'right',
        render: (_, inventory) => (
          <Button
            size="small"
            danger
            icon={<DeleteOutlined />}
            onClick={() =>
              Modal.confirm({
                title:
                  'Excluir inventário?',
                content:
                  'A exclusão não desfaz o ajuste de estoque realizado anteriormente.',
                okText: 'Excluir',
                cancelText: 'Cancelar',
                okButtonProps: {
                  danger: true,
                },
                onOk: () =>
                  deleteInventory(
                    inventory.id,
                  ),
              })
            }
          />
        ),
      },
    ]}
  />
</Modal>
      <Modal
        title={
          selectedPrize
            ? `Movimentar estoque — ${selectedPrize.name}`
            : 'Movimentar estoque'
        }
        visible={movementModalOpen}
        onCancel={closeMovementModal}
        footer={null}
        destroyOnClose
        width={680}
      >
        <Form
          layout="vertical"
          form={movementForm}
          onFinish={submitMovement}
        >
          <Form.Item
            name="action"
            label="Tipo de movimentação"
            rules={[
              {
                required: true,
                message:
                  'Selecione a movimentação',
              },
            ]}
          >
            <Radio.Group
              onChange={
                handleMovementTypeChange
              }
            >
              <Space wrap>
                <Radio.Button value="entry">
                  <PlusCircleOutlined />{' '}
                  Entrada
                </Radio.Button>

                <Radio.Button value="exit">
                  <MinusCircleOutlined />{' '}
                  Saída
                </Radio.Button>

                <Radio.Button value="return">
                  <ReloadOutlined />{' '}
                  Devolução
                </Radio.Button>

                <Radio.Button value="adjust">
                  <SettingOutlined />{' '}
                  Ajuste
                </Radio.Button>
              </Space>
            </Radio.Group>
          </Form.Item>

          {movementType !==
          'adjust' ? (
            <Form.Item
              name="quantity"
              label="Quantidade"
              rules={[
                {
                  required: true,
                  message:
                    'Informe a quantidade',
                },
                {
                  type: 'number',
                  min: 1,
                  message:
                    'Informe uma quantidade maior que zero',
                },
              ]}
            >
              <InputNumber
                min={1}
                precision={0}
                style={{
                  width: '100%',
                }}
              />
            </Form.Item>
          ) : (
            <Form.Item
              name="newStock"
              label="Novo estoque disponível"
              extra="Informe a quantidade real existente no estoque."
              rules={[
                {
                  required: true,
                  message:
                    'Informe o novo estoque',
                },
                {
                  type: 'number',
                  min: 0,
                  message:
                    'O estoque não pode ser negativo',
                },
              ]}
            >
              <InputNumber
                min={0}
                precision={0}
                style={{
                  width: '100%',
                }}
              />
            </Form.Item>
          )}

          <Form.Item
            name="notes"
            label="Observação"
          >
            <Input.TextArea
              rows={4}
              placeholder="Informe o motivo da movimentação"
            />
          </Form.Item>

          <Space>
            <Button
              type="primary"
              htmlType="submit"
              loading={
                submittingMovement
              }
            >
              Registrar movimentação
            </Button>

            <Button
              onClick={
                closeMovementModal
              }
            >
              Cancelar
            </Button>
          </Space>
        </Form>
      </Modal>

      <Modal
        title={
          selectedPrize
            ? `Configuração diária — ${selectedPrize.name}`
            : 'Configuração diária'
        }
        visible={
          configurationModalOpen
        }
        onCancel={
          closeConfigurationModal
        }
        footer={null}
        destroyOnClose
        width={640}
      >
        <Alert
          showIcon
          type="info"
          style={{ marginBottom: 20 }}
          message="A configuração será aplicada somente à data selecionada."
        />

        <Form
          layout="vertical"
          form={configurationForm}
          onFinish={
            submitConfiguration
          }
        >
          <Form.Item
            name="date"
            label="Data"
            rules={[
              {
                required: true,
                message:
                  'Selecione a data',
              },
            ]}
          >
            <DatePicker
              format="DD/MM/YYYY"
              style={{
                width: '100%',
              }}
            />
          </Form.Item>

          <Form.Item
            name="enabled"
            label="Brinde habilitado nesta data"
            valuePropName="checked"
          >
            <Switch />
          </Form.Item>

          <Form.Item
            name="dailyLimit"
            label="Quantidade máxima no dia"
            extra="Deixe vazio para não limitar a quantidade diária."
          >
            <InputNumber
              min={0}
              precision={0}
              placeholder="Sem limite"
              style={{
                width: '100%',
              }}
            />
          </Form.Item>

          <Form.Item
            name="probabilityWeight"
            label="Peso da probabilidade nesta data"
            extra="Deixe vazio para utilizar o peso padrão cadastrado no prêmio."
          >
            <InputNumber
              min={0}
              precision={0}
              style={{
                width: '100%',
              }}
            />
          </Form.Item>

          <Form.Item
            name="notes"
            label="Observação"
          >
            <Input.TextArea
              rows={3}
              placeholder="Observação opcional"
            />
          </Form.Item>

          <Space>
            <Button
              type="primary"
              htmlType="submit"
              loading={
                submittingConfiguration
              }
            >
              Salvar configuração
            </Button>

            <Button
              onClick={
                closeConfigurationModal
              }
            >
              Cancelar
            </Button>
          </Space>
        </Form>
      </Modal>

      <Modal
        title={
          selectedPrize
            ? `Histórico — ${selectedPrize.name}`
            : 'Histórico de estoque'
        }
        visible={historyModalOpen}
        onCancel={closeHistoryModal}
        footer={null}
        destroyOnClose
        width={980}
      >
        <Table
          rowKey="id"
          loading={historyLoading}
          dataSource={movements}
          pagination={{
            pageSize: 10,
            showSizeChanger: false,
          }}
          scroll={{ x: 850 }}
          columns={[
            {
              title: 'Data',
              dataIndex: 'createdAt',
              width: 170,
              render: formatDateTime,
            },
            {
              title: 'Tipo',
              dataIndex: 'type',
              width: 140,
              render: (type) => (
                <Tag
                  color={
                    MOVEMENT_COLORS[
                      type
                    ] || 'default'
                  }
                >
                  {MOVEMENT_LABELS[
                    type
                  ] || type}
                </Tag>
              ),
            },
            {
              title: 'Quantidade',
              dataIndex: 'quantity',
              width: 110,
            },
            {
              title: 'Antes',
              dataIndex: 'stockBefore',
              width: 90,
            },
            {
              title: 'Depois',
              dataIndex: 'stockAfter',
              width: 90,
            },
            {
              title: 'Responsável',
              width: 180,
              render: (_, movement) =>
                movement.user?.name ||
                movement.user?.email ||
                'Sistema',
            },
            {
              title: 'Observação',
              dataIndex: 'notes',
              render: (value) =>
                value || '-',
            },
          ]}
        />
      </Modal>

      <Modal
        title={
          selectedPrize
            ? `Entregas — ${selectedPrize.name}`
            : 'Entregas do brinde'
        }
        visible={deliveriesModalOpen}
        onCancel={closeDeliveriesModal}
        footer={null}
        destroyOnClose
        width={1100}
      >
        <Table
          rowKey="id"
          loading={deliveriesLoading}
          dataSource={deliveries}
          pagination={{
            pageSize: 10,
          }}
          scroll={{ x: 1050 }}
          columns={[
            {
              title: 'Participante',
              width: 220,
              render: (_, delivery) => (
                <div>
                  <Text strong>
                    {delivery.spin
                      ?.participant
                      ?.name ||
                      'Não informado'}
                  </Text>

                  <div>
                    <Text type="secondary">
                      {delivery.spin
                        ?.participant
                        ?.phone ||
                        delivery.spin
                          ?.participant
                          ?.email ||
                        '-'}
                    </Text>
                  </div>
                </div>
              ),
            },
            {
              title: 'Status',
              dataIndex: 'status',
              width: 130,
              render: (status) => (
                <Tag
                  color={
                    DELIVERY_COLORS[
                      status
                    ] || 'default'
                  }
                >
                  {DELIVERY_LABELS[
                    status
                  ] || status}
                </Tag>
              ),
            },
            {
              title: 'Criada em',
              dataIndex: 'createdAt',
              width: 170,
              render: formatDateTime,
            },
            {
              title: 'Entregue em',
              dataIndex: 'deliveredAt',
              width: 170,
              render: formatDateTime,
            },
            {
              title: 'Entregue por',
              width: 180,
              render: (_, delivery) =>
                delivery.deliveredBy
                  ?.name ||
                delivery.deliveredBy
                  ?.email ||
                '-',
            },
            {
              title: 'Observação',
              dataIndex: 'notes',
              render: (value) =>
                value || '-',
            },
            {
              title: 'Ações',
              width: 210,
              fixed: 'right',
              render: (_, delivery) => (
                <Space>
                  {delivery.status ===
                    'PENDING' && (
                    <>
                      <Button
                        size="small"
                        type="primary"
                        onClick={() =>
                          confirmDelivery(
                            delivery.id,
                          )
                        }
                      >
                        Entregar
                      </Button>

                      <Button
                        size="small"
                        danger
                        onClick={() =>
                          cancelDelivery(
                            delivery.id,
                          )
                        }
                      >
                        Cancelar
                      </Button>
                    </>
                  )}

                  {delivery.status ===
                    'CANCELLED' && (
                    <Button
                      size="small"
                      onClick={() =>
                        reopenDelivery(
                          delivery.id,
                        )
                      }
                    >
                      Reabrir
                    </Button>
                  )}
                </Space>
              ),
            },
          ]}
        />
      </Modal>
    </>
  )
}

export default InventoryPage